import { render, staticRenderFns } from "./artist.vue?vue&type=template&id=474db7be&scoped=true&"
import script from "./artist.vue?vue&type=script&lang=js&"
export * from "./artist.vue?vue&type=script&lang=js&"
import style0 from "./artist.vue?vue&type=style&index=0&id=474db7be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474db7be",
  null
  
)

export default component.exports